import React from 'react';
import InnerHTML from '@Components/InnerHTML';

export function SubstanceCommercialSupplierInformationCellPrice(props) {
  const { priceValue, priceCurrency, priceText } = props;
  return (
    <InnerHTML
      tag="td"
      className='column-price'
      html={(priceValue && priceCurrency) ? priceValue + ' ' + priceCurrency : priceText}
    />
  );
}
